import { Anchor } from "@components/Anchor";
import { Row } from "@components/Flex";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body, Title4 } from "@components/Typography";
import { SUPPORT_EMAIL_URL } from "@constants";
import { useTheme } from "@hooks";
import { i18n, Translations } from "@i18n";
import { ListBulletPoint } from "./ListBulletPoint";
import { useStyles } from "./styles";

export const IRADisclaimer = () => {
  const { theme } = useTheme();

  return (
    <>
      <Body>
        To make a withdrawal request, please complete and sign the IRA Distribution form below, and
        return to{" "}
        <Anchor href={SUPPORT_EMAIL_URL} style={{ color: theme.link.default }}>
          support@futuremoney.co
        </Anchor>
        .
      </Body>
      <Spacing size={SpacingSizes.M} />
      <Title4>{i18n.t(Translations.IRADisclaimerFooterTitle)}</Title4>
      <Spacing size={SpacingSizes.XL} />

      <IRADisclaimerListItem
        title={i18n.t(Translations.IRADisclaimerTaxesTitle)}
        subtitle={i18n.t(Translations.IRADisclaimerTaxesSubtitle)}
      />
      <Spacing size={SpacingSizes.M} />

      <IRADisclaimerListItem
        title={i18n.t(Translations.IRADisclaimerRequiredFieldsTitle)}
        subtitle={i18n.t(Translations.IRADisclaimerRequiredFieldsSubtitle)}
      />
      <Spacing size={SpacingSizes.M} />

      <IRADisclaimerListItem
        title={i18n.t(Translations.IRADisclaimerAccountNumberTitle)}
        subtitle={i18n.t(Translations.IRADisclaimerAccountNumberSubtitle)}
      />
      <Spacing size={SpacingSizes.M} />
    </>
  );
};

type IRADisclaimerListItemProps = {
  title: string;
  subtitle?: string;
};

const IRADisclaimerListItem = ({ title, subtitle }: IRADisclaimerListItemProps) => {
  const styles = useStyles();

  return (
    <>
      <Row>
        <ListBulletPoint />
        <Title4 style={styles.title}>{title}</Title4>
      </Row>
      <Spacing size={SpacingSizes.XS} />
      {subtitle && <Body style={styles.subtitle}>{subtitle}</Body>}
    </>
  );
};
